export default __webpack_public_path__ + "static/characters_04_IM_Chewing0-b19466d672f1515eea861b346143342b.png";